import React, { useState } from 'react';
import { 
    Box, 
    Collapse, 
    IconButton, 
    Typography, 
    Paper,
    Divider
} from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

const CollapseSectionComponent = ({ section }) => {
    const [open, setOpen] = useState(false);

    const handleToggle = () => {
        setOpen(!open);
    };

    return (
        <Paper elevation={1} sx={{ mb: 2 }}>
            {/* En-tête cliquable */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: 2,
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: 'action.hover',
                    },
                }}
                onClick={handleToggle}
            >
                <Typography variant="h6" component="div">
                    {section?.r_sectionStatusDossier_c_sectione?.libelle || 'Section sans titre'}
                </Typography>
                <IconButton size="small">
                    {open ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
            </Box>

            <Divider />

            {/* Contenu repliable */}
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ p: 2 }}>
                    {section?.r_sectionStatusDossier_c_sectione ? (
                        <Typography variant="body1">
                            {section?.r_sectionStatusDossier_c_sectione?.libelle}
                        </Typography>
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            Aucun contenu disponible pour cette section.
                        </Typography>
                    )}
                    
                    {/* Vous pouvez ajouter d'autres éléments ici */}
                    {section?.items && (
                        <Box sx={{ mt: 2 }}>
                            {section.items.map((item, index) => (
                                <Typography key={index} variant="body2" sx={{ mb: 1 }}>
                                    • {item}
                                </Typography>
                            ))}
                        </Box>
                    )}
                </Box>
            </Collapse>
        </Paper>
    );
};

export default CollapseSectionComponent;